import React from 'react';
import { useNavigate } from 'react-router-dom';

export const QuickPracticeCard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <button
      className="quick-practice-card"
      onClick={() => navigate('/practice/0/0?mode=quick')}
    >
      <span className="quick-practice-icon">&#9889;</span>
      <div className="quick-practice-text">
        <strong>Quick Practice</strong>
        <span>5 questions &middot; ~3 min</span>
      </div>
      <span className="quick-practice-arrow">&rarr;</span>
    </button>
  );
};
